// Mock data for Precision Analytics LTD
// NOTE: All data here is MOCKED for the frontend-only build.

import { Radar, Activity, Store, ScanLine } from 'lucide-react';

export const IMAGES = {
  heroBrain: 'https://images.unsplash.com/photo-1603054400223-7c796e60ba9d',
  networkBurst: 'https://images.unsplash.com/photo-1597733336794-12d05021d510',
  dataNodes: 'https://images.unsplash.com/photo-1606778303077-3780ea8d5420',
  circuit: 'https://images.unsplash.com/photo-1603732551681-2e91159b9dc2',
  circuitClose: 'https://images.unsplash.com/photo-1608560610603-c7ebd7b0fc05',
  dataViz: 'https://images.unsplash.com/photo-1653549893012-b8b4fbe97630',
  earthNight: 'https://images.unsplash.com/photo-1663427929917-333d88949f7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxnbG9iYWwlMjBuZXR3b3JrJTIwZWFydGh8ZW58MHx8fHwxNzg2MDUwMjU3fDA&ixlib=rb-4.1.0&q=85',
  earthNetwork: 'https://images.unsplash.com/photo-1663427929868-3941f957bb36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxnbG9iYWwlMjBuZXR3b3JrJTIwZWFydGh8ZW58MHx8fHwxNzg2MDUwMjU3fDA&ixlib=rb-4.1.0&q=85',
  towerNight: 'https://images.pexels.com/photos/2352277/pexels-photo-2352277.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  connections: 'https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxkYXRhJTIwY29ubmVjdGlvbnN8ZW58MHx8fHwxNzg2MDUwMjU3fDA&ixlib=rb-4.1.0&q=85',
};

export const CAPABILITIES = [
  {
    icon: Activity,
    title: 'Mobile Network Performance',
    desc: 'We test network performance from both the operator and the consumer point of view, delivering a holistic picture of real-world experience.',
  },
  {
    icon: Radar,
    title: 'Consumer Experience Intelligence',
    desc: 'Everything we do is designed to reveal how consumers experience mobile networks in their everyday life \u2014 objectively and accurately.',
  },
  {
    icon: Store,
    title: 'Retail & Commerce Analytics',
    desc: 'From network operators to online retail, we deliver deep insight into consumer behavior across the entire commercial spectrum.',
  },
  {
    icon: ScanLine,
    title: 'Objective & Unbiased Assessment',
    desc: 'We provide accurate, unbiased assessment of performance in helpful and easy-to-understand terms \u2014 the metrics that matter.',
  },
];

export const STATS = [
  { value: 42, suffix: '+', label: 'Markets Measured' },
  { value: 180, suffix: 'M', label: 'Data Points Captured' },
  { value: 96, suffix: '', label: 'Networks Tested' },
  { value: 99.4, suffix: '%', label: 'Measurement Accuracy' },
];

export const APPROACH = [
  {
    step: '01',
    title: 'Measure',
    desc: 'Our unique technology captures the metrics that matter across live networks and consumer touchpoints.',
  },
  {
    step: '02',
    title: 'Analyze',
    desc: 'Advanced analytics transform raw signal into a complete, accurate view of the consumer environment.',
  },
  {
    step: '03',
    title: 'Advise',
    desc: 'We translate findings into helpful, easy-to-understand terms that drive confident decisions.',
  },
];

export const CONTACT_INFO = {
  email: 'info@precision-analytics-ltd.com',
};

export const NAV_LINKS = [
  { label: 'Home', to: '/#top' },
  { label: 'Approach', to: '/#approach' },
  { label: 'Capabilities', to: '/#capabilities' },
];
